'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DetectAdBlock = require('./DetectAdBlock');

var _DetectAdBlock2 = _interopRequireDefault(_DetectAdBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DetectAdBlock2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/DetectAdBlock/index.js
// module id = 571
// module chunks = 11